/**
 * Consistent screen-level header (declutter requirement: "consistent
 * header ... per screen (fleet, organism, family)"). `OrganismScreen`'s
 * panels each get their own header (`OrganismScreen.makePanel`); the fleet
 * and family screens are single-panel-ish pages, so they get one of these
 * instead of repeating the per-panel-header markup.
 */

import { attachTooltip } from "../ui/tooltip";

export function renderScreenHeader(title: string, tooltip: string): HTMLDivElement {
  const header = document.createElement("div");
  header.className = "obs-panel-header obs-screen-header";
  const titleEl = document.createElement("span");
  titleEl.className = "obs-panel-title";
  titleEl.textContent = title;
  attachTooltip(titleEl, tooltip);
  header.appendChild(titleEl);
  return header;
}
